import { render, staticRenderFns } from "./dept-tree.vue?vue&type=template&id=10dcff46&scoped=true&"
import script from "./dept-tree.vue?vue&type=script&lang=js&"
export * from "./dept-tree.vue?vue&type=script&lang=js&"
import style0 from "./dept-tree.vue?vue&type=style&index=0&id=10dcff46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10dcff46",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})


/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10dcff46')) {
      api.createRecord('10dcff46', component.options)
    } else {
      api.reload('10dcff46', component.options)
    }
    module.hot.accept("./dept-tree.vue?vue&type=template&id=10dcff46&scoped=true&", function () {
      api.rerender('10dcff46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dept-tree.vue"
export default component.exports